export default "__VITE_ASSET__B4C5S94Q__"